import * as v from "valibot";
import type { ApiSchema } from "../api/schema.ts";
import { ContractWithSuppliersSchema } from "./contractsApi.ts";

/**
 * Api schema for tender-package-service's /supply-chain resource: awarded
 * assessment packages and contracts with the suppliers on each, for one
 * workspace or across an organisation, for the supply chain risk map.
 */

// An assessment package that is live, under review or awarded, with no
// contract yet. Once a contract is created from it, the package is listed as
// that contract instead. Suppliers are only known once it is awarded.
export const SupplyChainPackageSchema = v.object({
  id: v.string(),
  name: v.string(),
  status: v.picklist(["ACTIVE", "REVIEW", "AWARDED"]),
  submissionDeadline: v.optional(v.string()),
  workspaceId: v.string(),
  suppliers: v.array(
    v.object({
      organisationId: v.string(),
      workspaceId: v.string(),
      name: v.string(),
    }),
  ),
});
export type SupplyChainPackage = v.InferOutput<typeof SupplyChainPackageSchema>;

export const SupplyChainSchema = v.object({
  packages: v.array(SupplyChainPackageSchema),
  contracts: v.array(ContractWithSuppliersSchema),
});
export type SupplyChain = v.InferOutput<typeof SupplyChainSchema>;

export const supplyChainApi = {
  getWorkspace: {
    method: "GET",
    path: "/supply-chain",
    description:
      "The caller workspace's supply chain: live, in-review and awarded " +
      "packages without a contract, and contracts, each with its suppliers.",
    context: "workspace",
    output: v.object({ data: SupplyChainSchema }),
  },
  getOrganisation: {
    method: "GET",
    path: "/supply-chain/organisation",
    description:
      "The supply chain across every workspace the caller can open in the " +
      "organisation, except those they are a guest in.",
    context: "organisation",
    output: v.object({ data: SupplyChainSchema }),
  },
} satisfies ApiSchema;
